<template>
       <span>
             <v-img
                 :src="innerSrc"
                 @click="dialog = true"
                 max-height="90"
                 max-width="90"
                 v-if="!avatar"
             />
           <v-avatar
               @click="dialog = true"
               v-if="avatar"
           >
               <img :src="innerSrc" height="90" width="90"/>
           </v-avatar>
             <v-dialog v-model="dialog" width="500">
                          <img :src="innerSrc">
             </v-dialog>
       </span>
</template>

<script>


    export default {
        name: "AvatarImageModal",
        props: {
            src: {
                type: [File, String]
            },
            avatar: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dialog: false,
                innerSrc: ''
            }
        },
        methods: {
            showImage() {
                this.dialog = true;
            }
        },
        watch: {
            src(new_value) {
                this.innerSrc = new_value;
            }
        },
        mounted() {
            if (this.src instanceof File) {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(this.src);
                fileReader.addEventListener('load', () => {
                    this.innerSrc = fileReader.result;
                });
            } else {
                this.innerSrc = this.src;
            }
        }
    }
</script>
